import { render, staticRenderFns } from "./im-contact-point-list.vue?vue&type=template&id=fadd0afc"
import script from "./im-contact-point-list.vue?vue&type=script&lang=js"
export * from "./im-contact-point-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fadd0afc')) {
      api.createRecord('fadd0afc', component.options)
    } else {
      api.reload('fadd0afc', component.options)
    }
    module.hot.accept("./im-contact-point-list.vue?vue&type=template&id=fadd0afc", function () {
      api.rerender('fadd0afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-contact-point-list.vue"
export default component.exports